import { createSlice } from "@reduxjs/toolkit";

export const addManufaturerSlice = createSlice({
  name: "addManufaturer",
  initialState: {
    listCountries: [],
    listStates: [],
    companyName: "",
    companyLogo: "",
    addressLineOne: "",
    addressLineTwo: "",
    country: "",
    state: "",
    city: "",
    pinCode: "",

    errorCompanyName: "",
    errorCompanyLogo: "",
    errorAddressLineOne: "",
    errorCountry: "",
    errorState: "",
  },
  reducers: {
    fillManufacturerData: (state, payload) => {
      state[payload.payload.fieldName] = payload.payload.value;
    },

    clearManufacturerData: (state) => {
      return {
        ...state,
        companyName: "",
        companyLogo: "",
        addressLineOne: "",
        addressLineTwo: "",
        country: "",
        state: "",
        city: "",
        pinCode: "",
        errorCompanyName: "",
        errorCompanyLogo: "",
        errorAddressLineOne: "",
        errorCountry: "",
        errorState: "",
      };
    },

    loginSuccess: (state, payload) => {
      state.isUserLoggedIn = true;
    },
    logOut: (state) => {
      state.isUserLoggedIn = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loginSuccess,
  logOut,
  fillManufacturerData,
  clearManufacturerData,
} = addManufaturerSlice.actions;

export default addManufaturerSlice.reducer;
